var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"title-page"},[_vm._v("Bloqueio de Empresas")]),_c('TableBlock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }